/** Максимальная оценка Дептранса. */
export const MAX_TA_RATE = 10;

/**
 * Формат оценки как в map-search: запятая-разделитель, всегда один знак после запятой,
 * а на максимуме — целое «10».
 */
export function formatTaRate(rate: number): string {
  if (rate >= MAX_TA_RATE) {
    return String(MAX_TA_RATE);
  }

  return rate.toLocaleString('ru-RU', {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
    useGrouping: false,
  });
}

/** Доля заполнения индикатора оценки: 0…1. */
export function getTaRateIndex(rate: number): number {
  return Math.min(rate, MAX_TA_RATE) / MAX_TA_RATE;
}
